import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCrop16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCrop16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 2a.5.5 0 0 1 .5.5V4h5c.371 0 .719.101 1.017.277l1.612-1.612a.53.53 0 0 1 .725-.019.47.47 0 0 1 .017.69l-1.648 1.647C11.899 5.281 12 5.63 12 6v5h1.5a.5.5 0 0 1 0 1H12v1.5a.5.5 0 0 1-1 0V12H6a2 2 0 0 1-2-2V5H2.5a.5.5 0 0 1 0-1H4V2.5a.5.5 0 0 1 .5-.5m5.76 3.034A1 1 0 0 0 10 5H5v5a1 1 0 0 0 .04.284.5.5 0 0 1 .089-.12l.371.336.371.335a.5.5 0 0 1-.18.116Q5.839 11 6 11h5V6a1 1 0 0 0-.034-.26L8.214 8.492l-1.699 1.699-.476.476-.125.125-.032.032-.008.008-.002.002v.001L5.5 10.5l-.371-.335.003-.003.008-.008.032-.032.125-.126.476-.475 1.7-1.7z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCrop16);
